export const Disabled = (props) => <div className="co-disabled">{props.children}</div>;
